import httpClient from '@/lib/httpClient'
import useAppStore from '@/store/useAppStore'
import useAuthStore from '@/store/useAuthStore'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useSwitchTeam({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const setCurrentTeamId = useAuthStore((state) => state.setCurrentTeamId)
  const setNumberOfPeriods = useAppStore((state) => state.setNumberOfPeriods)
  const setPeriodType = useAppStore((state) => state.setPeriodType)
  const queryClient = useQueryClient()

  const action = async ({ teamId }: { teamId: number }) => {
    const response = await httpClient.post('team/team/switch', {
      team_id: teamId,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      // Read period settings from the cache BEFORE invalidateQueries() clears it.
      // The cache data is still present synchronously at this point.
      const cachedTeams = queryClient.getQueryData<any[]>(['teams'])
      const switchedTeam = cachedTeams?.find((t) => t.id === variables.teamId)

      setCurrentTeamId(variables.teamId)
      toast.success('Space switched')
      queryClient.invalidateQueries()

      if (switchedTeam?.default_horizon) {
        setNumberOfPeriods(switchedTeam.default_horizon)
        setPeriodType(switchedTeam.period_type.toLowerCase())
      }
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
